import React from 'react'
import { LaptopOutlined, UserOutlined, ShoppingCartOutlined, PayCircleOutlined, HomeOutlined } from '@ant-design/icons'
import { IpcIcon } from '../icon'

const menuList = [
  {
    key: 'home',
    label: '首页',
    icon: <HomeOutlined />,
    path: '/'
  },
  {
    key: 'device',
    label: '设备管理',
    icon: <LaptopOutlined/>,
    children: [
      {
        key: 'device-list',
        label: '设备列表',
        path: '/device'
      },
      {
        key: 'device-records',
        label: '设备日志',
        path: '/device/records'
      },
      {
        key: 'config-template',
        label: '配置模板',
        path: '/device/config-template'
      }
    ]
  },
  {
    key: 'camera',
    label: '监控服务',
    icon: <IpcIcon/>,
    path: '/camera'
  },
  {
    key: 'shop',
    label: '设备选购',
    icon: <ShoppingCartOutlined/>,
    children: [
      {
        key: 'shop-list',
        label: '购买设备',
        path: '/shop'
      },
      {
        key: 'shop-records',
        label: '购买记录',
        path: '/shop/order'
      }
    ]
  },
  {
    key: 'customer',
    label: '客户管理',
    icon: <UserOutlined/>,
    children: [
      {
        key: 'customer-list',
        label: '客户列表',
        path: '/customer'
      },
      {
        key: 'customer-personalize',
        label: '个性化',
        path: '/customer/personalize'
      }
    ]
  },
  {
    key: 'finance',
    label: '财务',
    icon: <PayCircleOutlined/>,
    children: [
      {
        key: 'finance-records',
        label: '账户余额',
        path: '/finance'
      },
      {
        key: 'finance-renew',
        label: '设备续费',
        path: '/finance/renew'
      },
      {
        key: 'finance-renew-list',
        label: '续费记录',
        path: '/finance/renew/list'
      }
    ]
  }
]

export default menuList
